import type { Theme } from "@mui/material/styles";

import {
  ChartSettingEnum,
  type ChartSettingsState,
  type INewsSentiment,
  NewsSentimentEnum,
} from "~/feature/chart/types";
import { PlatformEnum } from "~/types/platform";

export const defaultChartSettings: ChartSettingsState = {
  [ChartSettingEnum.AUTOSCALE]: true,
  [ChartSettingEnum.X_AXIS]: true,
  [ChartSettingEnum.Y_AXIS]: true,
  [ChartSettingEnum.HORIZONTAL_GRID]: false,
  [ChartSettingEnum.VERTICAL_GRID]: false,
  [ChartSettingEnum.VOLUME]: true,
  [ChartSettingEnum.NEWS]: true,
};

export const colorByPlatform: Record<PlatformEnum, string> = {
  [PlatformEnum.KALSHI]: "#00DD94",
  [PlatformEnum.POLYMARKET]: "#2E5CFF",
  [PlatformEnum.LIMITLESS]: "#C8FF00",
  [PlatformEnum.PREDICTION_FUN]: "#6e57f9",
  [PlatformEnum.OPINION]: "#ed6432",
};

export const MAX_SELECTABLE_SERIES = Object.values(PlatformEnum).length;

export const Y_AXIS_WIDTH = 44;

export const PLOT_PADDING_Y = 14;

const paletteKeyByNewsSentiment: Record<
  INewsSentiment,
  "success" | "error" | null
> = {
  [NewsSentimentEnum.POSITIVE]: "success",
  [NewsSentimentEnum.NEGATIVE]: "error",
  [NewsSentimentEnum.NEUTRAL]: null,
};

export const getNewsSentimentColor = (
  theme: Theme,
  sentiment: INewsSentiment | null
): string => {
  const paletteKey = sentiment ? paletteKeyByNewsSentiment[sentiment] : null;

  return paletteKey ? theme.palette[paletteKey].main : theme.palette.grey[500];
};
